import React from 'react';
import NotificationsBubble from '../NotificationsBubble';
import { useEventNotifications } from '../../../../data/hooks/notifications/useEventNotifications';

function UnreadNotificationsBubble() {
    const notifications = useEventNotifications()

    return <NotificationsBubble>{notifications.length}</NotificationsBubble>;
}

export default UnreadNotificationsBubble;
